/** Installer view: ready-made posts from Ox Resin — tap "Use this post" to load it into the composer. */
import React from 'react';
import { Film, Lightbulb } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BRAND_LABEL = { all: 'All brands', probound: 'ProBound', proepoxy: 'ProEpoxy', prodecor: 'ProDecor' };

export function SuggestedPosts({ items, onUse }) {
  if (!items?.length) return null;
  return (
    <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5" data-testid="social-suggestions">
      <h2 className="font-bold text-slate-900 flex items-center gap-2"><Lightbulb className="w-5 h-5 text-amber-500" /> Ready-made posts from Ox Resin</h2>
      <p className="text-xs text-slate-500 mt-1">Pick one, tweak the words if you like, and post it to your own pages. Your business name and number are already filled in.</p>
      <div className="flex gap-3 overflow-x-auto pb-2 mt-3 -mx-5 px-5">
        {items.map((s) => (
          <div key={s.id} className="shrink-0 w-60 rounded-xl border border-slate-200 overflow-hidden flex flex-col" data-testid={`social-suggestion-${s.id}`}>
            {s.media ? (s.media.kind === 'video' ? <div className="aspect-square bg-black flex items-center justify-center text-white"><Film className="w-8 h-8" /></div> : <img src={s.media.url} alt="" className="aspect-square object-cover w-full" loading="lazy" />) : <div className="aspect-[3/1] bg-slate-100" />}
            <div className="p-3 flex-1 flex flex-col">
              <div className="text-[10px] uppercase tracking-wider text-slate-500">{BRAND_LABEL[s.brand] || s.brand}</div>
              <div className="font-bold text-slate-900 text-sm">{s.title}</div>
              <p className="text-xs text-slate-600 mt-1 line-clamp-4 whitespace-pre-wrap flex-1">{s.caption}</p>
              <Button size="sm" onClick={() => onUse(s)} className="mt-2 h-8 text-xs bg-slate-900 text-white" data-testid={`social-suggestion-use-${s.id}`}>Use this post</Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
